module.exports = __webpack_public_path__ + "static/media/certificate.3d31eb54.svg";